/**
 * Shared appearance for every Stripe Elements mount.
 *
 * The app renders on a near-black surface, but Elements was configured with
 * theme "stripe", which is built for light backgrounds — field labels came out
 * dark grey on black and were effectively invisible. "night" is Stripe's dark
 * theme; the variables below pull it onto the app's own palette.
 *
 * Kept in one place so the checkout, the upgrade modal and the upgrade page
 * cannot drift apart.
 */
export const stripeAppearance = {
  theme: "night",
  variables: {
    colorPrimary: "#de1b22",
    colorBackground: "#1c1c1e",
    colorText: "#ffffff",
    colorTextSecondary: "#c7c7cc",
    colorTextPlaceholder: "#8a8a8e",
    colorDanger: "#ff6b6b",
    borderRadius: "8px",
    spacingUnit: "4px",
  },
  rules: {
    ".Label": {
      color: "#e5e5e5",
      fontWeight: "500",
    },
    ".Input": {
      backgroundColor: "#2c2c2e",
      border: "1px solid #3a3a3c",
    },
    ".Input:focus": {
      border: "1px solid #de1b22",
      boxShadow: "0 0 0 1px #de1b22",
    },
    ".Tab": {
      backgroundColor: "#2c2c2e",
      border: "1px solid #3a3a3c",
    },
    ".Tab--selected": {
      backgroundColor: "#2c2c2e",
      border: "1px solid #de1b22",
    },
  },
};

export default stripeAppearance;
